import { DisplayObject } from 'pixi.js-legacy';
import { gameEventEmitter } from '@/src/events';

interface IMethodCall {
    method: () => void;
}

class ContextStateSubscriberService {
    private _permanentObjects: DisplayObject[] = [];
    private _permanentMethodCalls: IMethodCall[] = [];

    constructor() {
        this.addEvents();
    }

    public subscribeObject(displayObject: DisplayObject): void {
        if (this._permanentObjects.indexOf(displayObject) !== -1) {
            return;
        }

        this._permanentObjects.push(displayObject);
    }

    public subscribeMethod(method: () => void) {
        const subscribedMethod = { method };
        this._permanentMethodCalls.push(subscribedMethod);
    }

    private contextLost(): void {
        const allSubscribedObjects = [...this._permanentObjects];
        allSubscribedObjects.forEach((subscribedObject) => {
            subscribedObject.cacheAsBitmap = false;
            subscribedObject.renderable = true;
        });
    }

    private contextRestored(): void {
        const allSubscribedMethods = [...this._permanentMethodCalls];
        setTimeout(() => {
            allSubscribedMethods.forEach((subscribedMethod) => {
                subscribedMethod.method();
            });
        }, 0);
    }

    private addEvents(): void {
        gameEventEmitter.on('CONTEXT_LOST', this.contextLost, this);
        gameEventEmitter.on('CONTEXT_RESTORED', this.contextRestored, this);
    }
}

export const ContextStateSubscriber = new ContextStateSubscriberService();
